// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"TabelaEKompanive_containerDashboardP__rlhTk","mobileResponsive":"TabelaEKompanive_mobileResponsive__KUy0P"};